<script>
  import { onMount } from "svelte"
  import { querystring, push } from "svelte-spa-router"
  import Navbar from "../../../../../Shared/Navbar/index.svelte"
  import LoadingScreen from "../../../SinglePublish/Components/loadingScreen.svelte"
  import Footer from "../../../../../Shared/footer.svelte"
  import notify from "../../../../../Script/notify"
  import BadgePublish, { removeDataBadgePublish, updateBadgePublish } from "../../Stores/badge"
  import { fetchBadgeData, fetchDocumentDetails } from "../../Script/api"
  import { queryStringToJSON } from "../../../../../Script/queryString"
  import ApplicationState from "../../../../../Stores/applicationStates"

  let showLoading = false
  /**
   * @typedef {Object} closeNotification
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {closeNotification}
   */
  let closeNotification = {
    close() {},
  }

  let query = {}

  onMount(async () => {
    try {
      let badgeDetails = localStorage.getItem("P2BBadgePublish")
      // console.log(typeof badgeDetails)

      if (!badgeDetails) $BadgePublish = {}

      query = queryStringToJSON($querystring)

      // console.log($BadgePublish)

      if (query.badgeId || $BadgePublish.badgeId) {
        try {
          let badgeData = await fetchBadgeData(query.badgeId || $BadgePublish.badgeId) // presisting badge data
          // console.log({ badgeData })
          // console.log(badgeData.documentID, "For API call")
          let docData = await fetchDocumentDetails(badgeData.documentID)
          delete docData.id
          // console.log({ docData })

          badgeData = { ...badgeData, ...docData }
          // console.log({ badgeData })

          assignFetchedData(badgeData)
        } catch (error) {
          if (error == "P2BCODE::DOCUMENT_DOES_NOT_EXIST") removeDataBadgePublish(query.documentId)
          BadgePublish.update((badgePub) => {
            return (badgePub = {})
          })
          throw error
        }
      }
    } catch (error) {
      closeNotification.close()
      const info = "PAGE: Badge Publish (Intro Page)\nEVENT: onMount"
      closeNotification = notify.danger(error, info)
    }
  })

  const assignFetchedData = (data) => {
    try {
      $BadgePublish.badgeId = data.id
      $BadgePublish.domain = data.domain
      $BadgePublish.reference = data.name
      $BadgePublish.documentId = data.documentID
      if (data.metadata) $BadgePublish.metadata = JSON.parse(data.metadata)
      if (data.options) $BadgePublish.options = JSON.parse(data.options)
      if (data.dataHash) $BadgePublish.dataHash = data.dataHash
      if (data.fileHash) {
        $BadgePublish.uri = `/ipfs/${data.filename}`
        $BadgePublish.fileHash = data.fileHash
      }
      if (data.url) $BadgePublish.proposedURL = $ApplicationState.viewBase.replace("/v2/", `/v${data.version}/`) + data.url

      // console.log($BadgePublish)

      updateBadgePublish($BadgePublish)
    } catch (error) {
      console.error(error)
      throw "Error While Processing Data"
    }
  }

  const initiate = async () => {
    try {
      closeNotification.close()

      localStorage.removeItem("P2BBadgePublish")
      $BadgePublish = {}

      push(`/publish/badge/badgetemplate`)
    } catch (error) {
      console.error(error)
      const info = "PAGE: Badge Publish (Intro Page)\nEVENT: While initiating badge publish session"
      closeNotification = notify.danger(error, info)
    } finally {
      showLoading = false
    }
  }

  const handleResume = () => {
    try {
      let path
      if (!$BadgePublish.badgeId) path = "badgetemplate"
      // else if ($BadgePublish.dataHash) path = "doctemplate"
      else if (!$BadgePublish.fileHash) path = "doctemplate"
      // else if(!$BadgePublish.proposedURL) path = "preview"
      else path = "preview"
      // else path = "final"
      // if (!$BadgePublish.badgeId) push(`/publish/badge`)
      // else {
      // push(`/publish/badge/${path}?documentId=${$BadgePublish.documentId}${query.badgeId ? "&badgeId=" + query.badgeId : ""}`)
      push(`/publish/badge/${path}?documentId=${$BadgePublish.documentId}&badgeId=${$BadgePublish.badgeId}`)
      // }
      // console.log("resume")
    } catch (error) {
      console.error(error)
      const info = "PAGE: Badge Publish (Intro Page)\nEVENT: While resuming previous badge publish session"
      notify.danger(error, info)
    }
  }
</script>

<svelte:head>
  <title>Publish Badge</title>
</svelte:head>

<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] dark:bg-bodyblack">
  <Navbar />

  <div class="px-6 pb-40 pt-3">
    <div class="relative mx-auto h-full w-full max-w-[920px] rounded-md bg-[#f7f7f7] dark:bg-bodyblack">
      <div class="mt-6 flex min-h-[470px] w-full flex-col justify-between rounded-md bg-white p-6 dark:bg-mdGray mobile:p-12">
        <div class=" select-none space-y-3 opacity-100">
          <h1 class="leading text-3xl font-bold dark:text-white mobile:text-5xl">
            Badge <br />
            Publishing
          </h1>

          <div class="w-full sm:w-3/5">
            <p class="break-words text-justify text-sm text-gray-500 dark:text-gray-300 mobile:text-base">Effortlessly publish and share secure, domain-locked, blockchain-verified badges with DocChain—simply upload and receive a blockchain-secured badge for your confidence.</p>
          </div>
        </div>

        <div class="flex items-center justify-end">
          <div class="flex gap-3">
            {#if $BadgePublish.documentId && !$BadgePublish.proposedURL}
              <button type="button" on:click={handleResume} class:hidden={!$BadgePublish.documentId} class="flex h-9 w-fit min-w-[36px] cursor-pointer items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-blue-300 lg:px-4">
                <!-- {#if $BadgePublish.proposedURL || $BadgePublish.publiedDocId}
                <i class="fa-solid fa-eye" />
                <span class="select-none">&nbsp;&nbsp;View&nbsp;Badge&nbsp;</span>
              {:else} -->
                <i class="fa-solid fa-circle-play" />
                <span class="select-none">&nbsp;&nbsp;Resume&nbsp;</span>
                <!-- {/if} -->
              </button>
            {/if}
            <button disabled={showLoading} type="button" on:click={initiate} class="flex h-9 w-32 min-w-[36px] cursor-pointer items-center justify-center rounded-md border border-[#a0a1a580] bg-green-500 px-2 text-sm font-medium text-white hover:bg-green-600 hover:text-white focus:outline-none active:bg-green-500 disabled:cursor-not-allowed disabled:bg-green-300 lg:px-4">
              <i class="fa-solid {$BadgePublish.documentId && !$BadgePublish.proposedURL ? 'fa-rotate-left' : 'fa-circle-play'}" />
              <span class="select-none">&nbsp;&nbsp;{$BadgePublish.documentId && !$BadgePublish.proposedURL ? "Start New" : "Start"}&nbsp;</span>
            </button>
          </div>
        </div>
        {#if showLoading}
          <LoadingScreen msg={"Creating Badge ID"} />
        {/if}
      </div>
    </div>
  </div>

  <Footer />
</div>

<style>
  .leading {
    line-height: 4rem;
  }
</style>
